// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var connect = require('share/enhancers/Izenda.Connect');
  var observer = require('mobx-react').observer;
  const { curry } = require('lodash/fp');
  var roleSetupAction = compose(
    connect(),
    withHandlers({
      addRole: curry(function(props, e) {
        e.stopPropagation();
        var loader = props.loader;
        var store = props.store;
        props.validation.reset();

        if (!props.readOnly) {
          loader.startLoading();
          props
            .confirmDirtyForm(store.isDirty)
            .then(store.addRole.bind(store))
            .finally(loader.endLoading.bind(loader));
        }
      })
    }),
    observer
  );

  module.exports = roleSetupAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/MiddlePanel/Izenda.RoleListHeaderAction.js